import React from "react";
import connect from "../i18n/connect";
import {
  updateStocksListSource
} from "../redux/modules/tags";
import { getAllTags } from "../redux/modules/tagsService/selector";

export default function withAllAvailableTagsList(WrappedComponent) {
  let previousTags = null;
  let memoizedAllAvailableTags = {
    data: [],
    loading: false,
    error: null
  };

  const mapStateToProps = state => {
    const tags = getAllTags(state);

    if (previousTags !== tags) {
      previousTags = tags;
      memoizedAllAvailableTags = {
        data: tags,
        loading: false,
        error: null
      };
    }

    return {
      allAvailableTags: memoizedAllAvailableTags
    };
  };

  const mapDispatchToProps = {
    updateStocksListSource
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithAllAvailableTagsList extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithAllAvailableTagsList;
}
